module.exports = __webpack_public_path__ + "static/img/footOneImg1.31be93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footOneImg1.png
// module id = Tj3W
// module chunks = 1